import React, { useState } from "react";
import { FaTrash, FaPaperPlane, FaEdit } from "react-icons/fa";
import "./CommentBox.css";

const CommentBox = ({ position, commentText, isSaved, onSave, onCancel, onEdit, onDelete, user, canModify = true, rightOffset = "-206px" }) => {
  const [comment, setComment] = useState(commentText || "");
  const [isEditing, setIsEditing] = useState(!isSaved); // If new, start in edit mode
  const [isHovered, setIsHovered] = useState(false);

  // Function to get display name from user data
  const getDisplayName = (userData) => {
    if (!userData) return "Anonymous";
    
    // If backend provides display_name, use it
    if (userData.display_name) return userData.display_name;
    
    // If user has a name field, use it
    if (userData.name) return userData.name;
    
    // If user has first_name and last_name, combine them
    if (userData.first_name && userData.last_name) {
      return `${userData.first_name} ${userData.last_name}`;
    }
    
    // If user has first_name only, use it
    if (userData.first_name) return userData.first_name;
    
    // If user has last_name only, use it
    if (userData.last_name) return userData.last_name;
    
    // If user has email, format it nicely (show part before @)
    if (userData.email) {
      const emailName = userData.email.split('@')[0];
      return emailName.charAt(0).toUpperCase() + emailName.slice(1);
    }
    
    return "Anonymous";
  };

  // Function to get avatar initial
  const getAvatarInitial = (userData) => {
    if (!userData) return "?";
    
    const displayName = getDisplayName(userData);
    if (displayName === "Anonymous") return "?";
    
    return displayName.charAt(0).toUpperCase();
  };

  const displayName = getDisplayName(user);
  const avatarInitial = getAvatarInitial(user);

  return (
    <div
      className="comment-box"
      style={{
        top: `${position}px`,
        position: "absolute",
        right: rightOffset,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="comment-header">
        <div className="comment-arrow"></div>
        <div className="avatar">{avatarInitial}</div>
        <span className="username">{displayName}</span>
      </div>

      {isEditing ? (
        <textarea
          className="comment-input"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Add Comment"
        />
      ) : (
        <p className="comment-text">{comment}</p>
      )}

      {isEditing ? (
        // Show Save & Cancel buttons when editing
        <div className="comment-footer">
          <button className="comment-btn" onClick={() => { onSave(comment); setIsEditing(false); }} disabled={!comment.trim()}>
            <FaPaperPlane /> Comment
          </button>
          <button className="cancel-btn" onClick={onCancel}>
            <FaTrash /> Cancel
          </button>
        </div>
      ) : (
        // Show Edit & Delete buttons only for saved comments when hovered and allowed
        isSaved && isHovered && canModify && (
          <div className="comment-footer">
            <button className="comment-btn" onClick={() => setIsEditing(true)}>
              <FaEdit /> Edit
            </button>
            <button className="comment-btn" onClick={onDelete}>
              <FaTrash /> Delete
            </button>
          </div>
        )
      )}
    </div>
  );
};

export default CommentBox;
